export const generatePointPurchaseUrl = (retUrl: string) => {
  return `/me/points?retUrl=${encodeURIComponent(retUrl)}`
}
